import Service from '@ember/service';

import * as Sentry from '@sentry/ember';

export type SentryContext = Parameters<typeof Sentry.captureException>[1];

export default class SentryService extends Service {
  withScope(scopeFn: (scope: Sentry.Scope) => void): void {
    Sentry.withScope(scopeFn);
  }

  captureMessage(msg: string, level: Sentry.SeverityLevel = 'info'): void {
    Sentry.captureMessage(msg, level);
  }

  captureException(error: unknown, captureContext?: SentryContext): void {
    Sentry.captureException(error, captureContext);
  }
}

declare module '@ember/service' {
  interface Registry {
    sentry: SentryService;
  }
}
